export default class CampaignMailEditorCtrl {
    constructor($scope, $timeout, $window, $stateParams, $state, $q, $filter, Setting, SideMenu, Tag, Campaign, SweetAlert, Segment, Events, AbTest) {
        SideMenu.setActive('campaign');

        this._scope = $scope;
        this._translator = $filter('translate');
        this._state = $state;
        this._window = $window;
        this._stateParams = $stateParams;
        this._q = $q;
        this._timeout = $timeout;

        this.settingRepo = Setting;
        this.segmentRepo = Segment;
        this.tagRepo = Tag;
        this.campaignRepo = Campaign;
        this.abTestRepo = AbTest;
        this.alerter = SweetAlert;
        this.eventHandler = Events;

        this.availabilityView = false;
        this.imageBankVisible = false;
        this.loadedTags = false;
        this.loadedSubscribers = false;
        this.status = 'sender';

        this.preview = {
            to: this._window.localStorage.getItem('preview_to') ? this._window.localStorage.getItem('preview_to') : null
        };

        this.dispatcher = {
            id: null,
            subscribers: [],
            tags: [],
            segments: [],
            email: {from_name: '', from_email: '', subject: '', email_template_id: 0, language: null},
            message_type_id: 1
        };

        this.abTest = {
            campaigns: []
        };

        this.tagRepo.all().then((tags) => {
            this.activeTags = tags.data;
            this._scope.$broadcast('mailEditor:tags:fetched', this.activeTags);
        });

        this.segmentRepo.all().then((segments) => {
            this.activeSegments = segments.data;
            this._scope.$broadcast('mailEditor:segments:fetched', this.activeSegments);
        });

        if (this._stateParams.id) {
            this.templateSelected = true;

            this.campaignRepo.find(this._stateParams.id).then((campaign) => {
                this.dispatcher = campaign.data;
                this.dispatcher.email = campaign.data.email.data;

                if (this.dispatcher.campaign_status_id == 4) {
                    if (!this.dispatcher.abTestActive) {
                        this.campaignRepo.getSchedule(this._stateParams.id, 'scheduled', this.dispatcher.message_type_id).then((schedule) => {
                            this.formatSchedule(schedule);
                        });
                    } else {
                        this.abTestRepo.getSchedule(this.dispatcher.ab_test_id, 'scheduled').then((schedule) => {
                            this.formatSchedule(schedule);
                        });
                    }
                }

                this.dispatcher.message_type = 'email';
                this.loadedTags = this.dispatcher.tags ? this.dispatcher.tags : false;
                this.loadedSubscribers = this.dispatcher.subscribers ? this.dispatcher.subscribers : false;
                this.loadedSegments = [];

                angular.forEach(this.dispatcher.segments, (segment) => {
                    this.loadedSegments.push(segment.id);
                });

                if (this.dispatcher.abTestActive) {
                    this.abTestRepo.find(this.dispatcher.ab_test_id).then((response) => {
                        this.abTest = response.data;

                        if (this.abTest.campaigns.length == 1) {
                            this.setStatus('abTest');
                        }

                        if (this.abTest.ab_test_status_id == 4) {
                            let finishAt = moment(this.abTest.finish_at, 'YYYY-MM-DD HH:mm:ss');
                            this.scheduledFor = finishAt.subtract(parseInt(this.abTest.hours), 'hours');
                            this.scheduledFor = this.scheduledFor.format('YYYY-MM-DD HH:mm');
                        }
                    });
                }

                this._scope.$broadcast('mailEditor:state:init', {
                    dispatcher: this.dispatcher,
                    dispatcherType: 'campaign',
                    htmlSource: 'campaign/' + this._stateParams.id + '/emailContent',
                    plainSource: 'campaign/' + this._stateParams.id + '/emailContent',
                    templateId: this.dispatcher.email?.email_template_id
                });
            });
        } else {
            this.settingRepo.findSenderDetail().then((details) => {
                this.dispatcher.email.from_name = details.company || details.name;
                this.dispatcher.email.from_email = details.email;
            });

            this._timeout(() => {
                this.selectTemplate();
            });
        }

        this._scope.$on('mailEditor:content:loaded', () => {
            this.contentLoaded = true;
        });

        this._scope.$on('mailEditor:setLanguage', (event, language) => {
            this.dispatcher.email.language = {data: { code: language }};
        });

        this._scope.$on('mailEditor:template:selected', (event, templateId) => {
            if (this.dispatcher.message_type_id === 1 && !this.dispatcher.email) {
                this.dispatcher.message_type = 'email';
                this.dispatcher.email = {
                    from_email: '',
                    from_name: '',
                    ga_utm_campaign: '',
                    ga_utm_term: '',
                    email_template_id: templateId
                };
            }

            this.dispatcher.email.email_template_id = templateId;

            this._scope.$broadcast('mailEditor:state:init', {
                dispatcher: this.dispatcher,
                dispatcherType: 'campaign',
                htmlSource: 'template/' + templateId + '/htmlContent',
                plainSource: 'template/' + templateId + '/plainContent',
                templateId: this.dispatcher.email.email_template_id
            });

            this.templateSelected = true;
        });

        this._scope.$on('mailEditor:template:notChanged', () => {
            this.templateSelected = true;
        });

        this._scope.$on('imageBank:close', () => {
           this.imageBankVisible = false;
        });

        this._scope.$on('account:changed', () => {
            this._state.go('campaign.index');
        });
    }

    setView() {
        this.availabilityView = ! this.availabilityView;
    };

    formatSchedule(schedule) {
        this.scheduledFor = moment(schedule.date, 'YYYY-MM-DD HH:mm');
        this.scheduledFor.hours(parseInt(schedule.time.hour));
        this.scheduledFor.minutes(parseInt(schedule.time.minutes));
        this.scheduledFor = this.scheduledFor.format('YYYY-MM-DD HH:mm');
    };

    selectTemplate() {
        this.templateSelected = false;
        this._scope.$broadcast('mailEditor:templateSelector:show');
    };

    validRecipient() {
        return (this.dispatcher.subscribers.length > 0
            || this.dispatcher.tags.length > 0
            || this.dispatcher.segments.length > 0
        );
    };

    validSender() {
        return this.dispatcher.email.from_name.length > 0 && this.dispatcher.email.from_email
    };

    validSenderEmail() {
        if (this.dispatcher.email.from_email.includes('[CustomField')) {
            return true;
        }

        let re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((([a-zA-Z0-9][a-zA-Z\-0-9]*\.)+[a-zA-Z]{2,}))$/gm;
        return re.test(this.dispatcher.email.from_email);
    }

    validSubject() {
        return this.dispatcher.email.subject.length > 0;
    };

    validContent() {
        return $(new DOMParser().parseFromString(this.dispatcher.email.htmlContent, "text/html"))
                .find("body").children().length > 0;
    };

    validPreview() {
        let returnArray = [];

        if (! this.preview.to) {
            returnArray.push(this._translator('CAMPAIGN:FLASH:PREVIEW_RECIPENT_ERROR'));
        } if (! this.validSender()) {
            returnArray.push(this._translator('CAMPAIGN:FLASH:INVALID_SENDER'));
        } if (! this.validSubject()) {
            returnArray.push(this._translator('CAMPAIGN:FLASH:INVALID_SUBJECT'));
        } if (this.preview.to && this.preview.to.split(',').length > 30) {
            returnArray.push(this._translator('CAMPAIGN:PREVIEW:TOO_MANY_RECIPENTS'));
        }

        return returnArray
    };

    sendPreview() {

        if (this.validPreview().length > 0) {
            let message = '';

            angular.forEach(this.validPreview(), (value) => {
                message += value + '\n';
            });

            return this.alerter.swal({
                title: 'Error',
                text: message,
                type: 'error'
            });
        }

        this.save().then(() => {
            this._window.localStorage.setItem('preview_to', this.preview.to);
            this.campaignRepo.sendPreview(this.dispatcher.id, this.preview.to, this.dispatcher.email.id).then(() => {
                this.eventHandler.flashEvent('notification', this._translator('CAMPAIGN:FLASH:PREVIEW'))
            }, (error) => {
                if (error.status == 400) {
                    this.alerter.swal({
                        title: 'Error',
                        text: this._translator('CAMPAIGN:FLASH:PREVIEW_RECIPENT_FORMAT_ERROR'),
                        type: 'error'
                    });
                } else if (error.status == 413) {
                    this.alerter.swal({
                        title: 'Error',
                        text: this._translator('CAMPAIGN:PREVIEW:TOO_MANY_RECIPENTS'),
                        type: 'error'
                    });
                } else if (error.status == 403) {
                    this.alerter.swal({
                        title: 'Error',
                        text: this._translator('NOTIFICATION:SUBJECT:INVALID_URL'),
                        type: 'error'
                    });
                } else {
                    this.alerter.swal({
                        title: 'Error',
                        text: this._translator('CAMPAIGN:FLASH:PREVIEW_ERROR'),
                        type: 'error'
                    });
                }
            });
        });
    };

    toggleImageBank() {
        this.imageBankVisible = ! this.imageBankVisible;
        this._scope.$emit('imageBank:toggle');
    }

    validTfs() {
        return this.validRecipient() && this.validSender() && this.validSubject()
    };

    summary() {
        this.save(true).then(() => {
            let type = this.dispatcher.message_type_id == 1 ? 'email' : 'text_message';
            this._state.go('campaign.summary', { id: this.dispatcher.id, type: type });
        });
    };

    goToCampaign(id) {
        this.save().then(() => {
            this._state.go('campaign.edit', { id: id });
        });
    };

    activateAbTest() {
        let errorArray = [];

        if (! this.dispatcher.email.from_name) {
            errorArray.push(this._translator('AUTOMATION:FLASH:INVALID_SENDER_NAME'));
        }

        if (! this.dispatcher.email.from_email) {
            errorArray.push(this._translator('AUTOMATION:FLASH:INVALID_SENDER_EMAIL'));
        }

        if (! this.dispatcher.email.subject) {
            errorArray.push(this._translator('AUTOMATION:FLASH:INVALID_SUBJECT'));
        }

        if (this.dispatcher.tags.length == 0 && this.dispatcher.segments.length == 0) {
            errorArray.push(this._translator('CAMPAIGN:NO_RECIPENTS_ERROR'));
        }

        if (errorArray.length > 0) {
            var errorText = '';

            errorArray.forEach(function(error) {
                errorText += error + '\n';
            });

            return this.alerter.swal({
                title: 'Error',
                text: errorText,
                type: 'error'
            });
        }

        this.abTestRepo.create().then((abTest) => {
            this.dispatcher.ab_test_id = abTest.id;

            this.save().then(() => {
                this.abTest.campaigns.push(this.dispatcher);
                this.dispatcher.abTestActive = true;

                this.setStatus('abTest');
            })
        }, (error) => {
            this.alerter.swal({
                title: 'Error',
                text: this._translator('CAMPAIGN:AB:ACTIVATION_ERROR'),
                type: 'error'
            });
        });
    };

    copyABCampaign() {
        this.save().then(() => {
            this.campaignRepo.copy(this.dispatcher.id).then(() => {
                this.abTestRepo.find(this.dispatcher.ab_test_id).then((abTest) => {
                    this.abTest = abTest.data;
                });
            });
        });
    };

    deleteABCampaign(id) {
        this.campaignRepo.destroy(id).then(() => {
            this.abTestRepo.find(this.dispatcher.ab_test_id).then((abTest) => {
                this.abTest = abTest.data;
            });
        });
    };

    flashElement(element, numIterations) {
        this._timeout(() => {
            $(element).toggleClass('red-border');
            if (numIterations > 0) {
                this.flashElement(element, numIterations - 1);
            }
        }, 1000);
    };

    handleSaveError(errorCode) {
        if (errorCode == 1) {
            this.eventHandler.flashEvent('error', this._translator('CAMPAIGN:FLASH:MISSING_SENDER_EMAIL'));

            this._timeout(function() {
                var inputElement = $('#sender-email').first();
                inputElement.focus();
                this.flashElement(inputElement, 7);
            });
        } else if (errorCode == 2) {
            this.eventHandler.flashEvent('error', this._translator('CAMPAIGN:FLASH:MISSING_SENDER_NAME'));

            this._timeout(function() {
                var inputElement = $('#sender-name').first();
                inputElement.focus();
                this.flashElement(inputElement, 7);
            });
        }
    };

    save(summary = false) {
        let htmlContent, plainContent;
        let deferred = this._q.defer();
        this._scope.$broadcast('mailEditor:state:saving');
        $('.longSentences').contents().unwrap();
        $('.exclamation').contents().unwrap();

        let createCampaign = (deferred) => {
            this.campaignRepo.create(this.dispatcher).then((response) => {
                if (response.error) {
                    this.eventHandler.flashEvent('notification', this._translator('CAMPAIGN:FLASH:STORE_ERROR'));
                    deferred.reject();
                } else {
                    this.dispatcher = response;
                    this.eventHandler.flashEvent('notification', this._translator('CAMPAIGN:FLASH:CREATED'));
                    if (!summary) {
                        this._state.go('campaign.edit', { id: response.id, type: 'email' });
                    }
                    deferred.resolve();
                }
            }, (error) => {
                this.handleSaveError(error.data.code);
            });
        };

        let updateCampaign = (deferred) => {
            let ABTestUpdateQueue = [];
            this.campaignRepo.update(this.dispatcher.id, this.dispatcher).then((response) => {
                // Make sure all recipients match on all versions
                if (this.dispatcher.abTestActive && this.abTest.campaigns.length > 1) {
                    this.dispatcher.ab_test_id = this.abTest.id;
                    this.abTest.campaigns.forEach((campaign, index) => {
                        if (campaign.id === this.dispatcher.id) {
                            this.abTest.campaigns[index] = this.dispatcher;
                        }
                    });

                    angular.forEach(this.abTest.campaigns, (campaign) => {
                        campaign.ab_test_id = this.abTest.id;
                        campaign.tags = this.dispatcher.tags;
                        campaign.segments = this.dispatcher.segments;
                        campaign.subscribers = this.dispatcher.subscribers;
                        campaign.message_type = this.dispatcher.message_type;

                        let query = this.campaignRepo.update(campaign.id, campaign).then((result) => {});
                        ABTestUpdateQueue.push(query);
                    });
                }

                if (response.error) {
                    this.eventHandler.flashEvent('error', this._translator('CAMPAIGN:FLASH:UPDATE_ERROR'));
                    deferred.reject();
                } else {
                    if (ABTestUpdateQueue.length) {
                        Promise.all(ABTestUpdateQueue)
                            .then(() => {
                                this.eventHandler.flashEvent('notification', this._translator('CAMPAIGN:FLASH:SAVED'));
                                deferred.resolve();
                            }).catch(error => {
                                this.eventHandler.flashEvent('error', this._translator('CAMPAIGN:FLASH:UPDATE_ERROR'));
                                deferred.reject();
                            });
                    } else {
                        this.eventHandler.flashEvent('notification', this._translator('CAMPAIGN:FLASH:SAVED'));
                        this._scope.$broadcast('dispatcher:updated');
                        deferred.resolve();
                    }
                }
            }, (error) => {
                this.handleSaveError(error.data.code);
            });
        };

        this._scope.$broadcast('mailEditor:prepareHtml', (content) => {
            htmlContent = content;

            this._scope.$broadcast('plainEditor:getContent', (plain) => {
                plainContent = plain;

                this.dispatcher.email.htmlContent = htmlContent;
                this.dispatcher.email.plainContent = plainContent;
                this.dispatcher.name = this.dispatcher.email.subject;

                if (! this.validContent()) {
                    this.eventHandler.flashEvent('error', this._translator('CAMPAIGN:FLASH:CONTENT_EMPTY'));
                    deferred.reject();
                } else if (! this.validSenderEmail()) {
                    this.eventHandler.flashEvent('error', this._translator('MAILEDITOR:FLASH:INVALID_FROM_EMAIL'));
                    deferred.reject();
                } else {
                    this.dispatcher.id === null ? createCampaign(deferred) : updateCampaign(deferred);
                }
            });
        });

        return deferred.promise;
    };

    setStatus(status) {
        this.status = status
    };

    toIndex() {
        let statusIdToName = {
            1: 'draft',
            2: 'sending',
            3: 'sent',
            4: 'scheduled',
            6: 'paused'
        };
        
        let toTab = statusIdToName[this.dispatcher.campaign_status_id];
        let view = this._window.localStorage.getItem('settings.campaign.view');
        if (!toTab) {
            toTab = 'sent'
        }
        this._state.go('campaign.folder', { folder: toTab, view: view ? view : 'cards', page: 1})
    };
};
